import { useAdminStore } from "@/stores/admin-store";
import { useLocation, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import {
	GLOBAL_CLIENTS_PAGE,
	isClientRoute,
	isNeutralRoute,
} from "./client-context";

/**
 * Keeps the page and the context mode in agreement whenever the URL changes:
 *
 * - a client page (`/client/...`) with no selected client → the Clients list;
 * - a global page while a client is selected → client mode ends (founder
 *   decision 2026-09-14: exit automatically, no prompt).
 *
 * Runs on pathname changes only, never on store changes: `enterClient`
 * selects the client and then navigates, and Create Client selects before
 * navigating to onboarding — reacting to the store would clear the selection
 * on the global page in between.
 */
export function ContextRouteSync() {
	const { pathname } = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if (isNeutralRoute(pathname)) return;
		const { selectedClientId, clearClientContext } =
			useAdminStore.getState();

		if (isClientRoute(pathname)) {
			if (!selectedClientId) {
				navigate({ to: GLOBAL_CLIENTS_PAGE, replace: true });
			}
			return;
		}

		if (selectedClientId) {
			clearClientContext();
		}
	}, [pathname, navigate]);

	return null;
}
